import { getMerchInfo, logout as userLogout, MerchInfo } from '@src/apis/merchant';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { useMerchantInfo } from './context';

export function useUser() {
  const [merchInfo, setMerchInfo] = useState<MerchInfo>();
  useEffect(() => {
    void getMerchInfo().then((merch) => {
      window.aegis?.setConfig({
        uin: merch.wpMchid,
      });

      setMerchInfo(merch);
    });
  }, []);

  return { merchInfo };
}

export const useLogout = () => {
  const navigate = useNavigate();

  const { setInfo } = useMerchantInfo();

  function logout() {
    void userLogout().then(() => {
      setTimeout(() => {
        navigate('/merchants/login');
        setInfo?.(undefined);
      }, 1000);
    });
  }

  return { logout };
};
